import { useWindowSize } from '../../../../core/hooks/windowSize';

const OFFSET_FROM_WINDOW = 72;

export function useSiteScenarioWidthEstimate(ratio = 1) {
  const { width } = useWindowSize();
  return Math.floor((width - OFFSET_FROM_WINDOW) * ratio);
}
